import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { UserType } from '@customTypes/user';

const useGetUsersList = () => {
  const [users, setUsers] = useState<UserType[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getUsers = useCallback(async ({ page = 1, limit = 10, name = '', email = '' }) => {
    setLoading(true);
    try {
      const response = await api.get('/user', {
        params: {
          pageIndex: page,
          pageLimit: limit,
          name,
          email,
        },
      });

      setUsers(response.data.data);
      setTotalPages(response.data.total);
    } catch (error) {
      toast.error('Erro ao carregar os usuários. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to get users list'), {
        error,
        name,
        email,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getUsers,
    users,
    totalPages,
    loading,
  };
};

export default useGetUsersList;
